import React from "react";
import cn from "classnames";
import { AniLink } from "@/components/global-navigation";
import * as styleConstants from "@/constants/style";
import { useRoute } from "@/utils";
import typograf from "@/plugins/typograf";
import AniLogo from "@/components/kit/ani-logo";

type PageTitleProps = {
  className?: string;
  border?: boolean;
};
const PageTitle: React.FC<PageTitleProps> = ({
  className,
  children,
  border = true,
  ...rest
}) => {
  const route = useRoute();

  return (
    <div className={className} {...rest}>
      <div className={styleConstants.container}>
        <div
          className={cn(
            { "border-b-2 border-solid desktop1280:border-b-3": border },
            "pt-4 pb-6",
            "tablet:flex tablet:items-start tablet:pt-6 tablet:pb-10",
            "desktop:pt-5 desktop:pb-12",
            "desktop1280:pt-7 desktop1280:pb-15",
            "desktop1440:pb-17"
          )}
        >
          <div className="hidden tablet:block w-1/8 tablet:mt-1">
            <AniLink to={route("home")}>
              <AniLogo className="max-w-full h-auto" />
            </AniLink>
          </div>

          <div className="hidden tablet:block tablet:w-5/24 desktop:w-1/6" />

          <h1 className="tablet:flex-1 desktop:-ml-1">
            {typeof children === "string" ? typograf(children) : children}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
